import React, { useRef } from 'react';
import { Bold, Italic, Underline } from 'lucide-react';

const WRAPPERS = {
  bold:      { before: '**',  after: '**' },
  italic:    { before: '*',   after: '*' },
  underline: { before: '<u>', after: '</u>' },
};

const s = {
  wrap:    { marginBottom: '12px' },
  toolbar: { display: 'flex', gap: '4px', marginBottom: '4px' },
  btn:     { width: '26px', height: '26px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #ddd', borderRadius: '4px', background: '#fff', cursor: 'pointer', color: '#555' },
  field:   (rows) => ({ width: '100%', padding: '8px 10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', minHeight: `${rows * 20 + 16}px`, resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit' }),
};

// A markdown-authoring textarea with a Bold/Italic/Underline toolbar. Wraps
// the current selection in **bold**, *italic*, or <u>underline</u> markup —
// rendered back out by <MarkdownText> wherever the value is displayed.
// Plain Enter key line breaks work too, via the remark-breaks plugin on
// the render side.
export default function RichTextField({ value, onChange, rows = 3, placeholder, required }) {
  const ref = useRef(null);

  const applyWrap = (kind) => {
    const el = ref.current;
    if (!el) return;
    const { before, after } = WRAPPERS[kind];
    const start = el.selectionStart;
    const end   = el.selectionEnd;
    const selected = value.slice(start, end);
    const next = value.slice(0, start) + before + selected + after + value.slice(end);
    onChange(next);
    requestAnimationFrame(() => {
      el.focus();
      const cursorStart = start + before.length;
      el.setSelectionRange(cursorStart, cursorStart + selected.length);
    });
  };

  return (
    <div style={s.wrap}>
      <div style={s.toolbar}>
        <button type="button" style={s.btn} onClick={() => applyWrap('bold')} title="Bold"><Bold size={13} /></button>
        <button type="button" style={s.btn} onClick={() => applyWrap('italic')} title="Italic"><Italic size={13} /></button>
        <button type="button" style={s.btn} onClick={() => applyWrap('underline')} title="Underline"><Underline size={13} /></button>
      </div>
      <textarea
        ref={ref}
        style={s.field(rows)}
        rows={rows}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        required={required}
      />
    </div>
  );
}
